import React, {useEffect} from 'react'
import { Box } from '@mui/system'
import Sidebar from './sidebar'

import { DataGrid } from '@mui/x-data-grid';
import CustomToolbar from './CustomToolbarPrint';
import { useNavigate } from 'react-router-dom';


import { collection, query, getDocs, where } from "firebase/firestore"; 
import {db} from "../firebase.js";


export default function Dpc() {
    const [rows, setRows] = React.useState([])

    let arr = [];
  
    useEffect( () => {
      test()
  
      async function test(){
        arr=[]
        getData()
      }
  
      setRows(arr)
      console.log(arr)
  
  }, []);
  
  async function getData (){
    console.log("me chala")
    let arr = []
    const q = query(collection(db, "employee"), where("licenceNumber", "!=", ""));
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      let obj = doc.data();
      Object.assign(obj, {doc: doc.id});
      console.log(obj)
      arr.push(obj)
     });  
  
     setRows(arr)
  
  }

  
  
    const navigate = useNavigate();
    const columns = [
     
        { field: 'firstName', headerName: 'Name', width: 150 },
        {field: 'surName', headerName: 'Sur Name',width: 150},
        { field: 'licenceNumber', headerName: 'Job Title' , width: 150 },
        { field: 'nationalIns', headerName: 'National Insurance' , width: 150 },
        { field: 'address1', headerName: 'Address 1' , width: 150 },
        { field: 'address2', headerName: 'Address 2' , width: 150 },
        { field: 'town', headerName: 'Town/County' , width: 150 },
        { field: ' postcode', headerName: ' Postcode' , width: 150 },
      
    ];
  
    const handleRowClick = (params) => {
      //console.log(params.row);
      navigate("/profile",{
        state: {
          employee: params.row,
        }
      });
    };
    
    return (
  
        
  
        <Box sx={{ display: 'flex' }}>
          <Sidebar />
       
         
          <Box component="main" sx={{ flexGrow: 1, p: 3 }} style={{marginTop: "50px", justifyContent: "center", alignItems: "center"}}>
         
          <div style={{ height: 640, width: '100%'}}>
              <DataGrid
                  rows={rows}
                  columns={columns}
                  pageSize={10}
                  rowsPerPageOptions={[5]}
                  //checkboxSelection
                  onRowDoubleClick={handleRowClick}
                  components={{
                    Toolbar: CustomToolbar,
                  }}
              />
          </div>
          
        </Box>
       
          
      </Box>
  
      
    )
}
